import { createSlice } from '@reduxjs/toolkit';
import { detectPlatform, PLATFORMS } from '../../../constants/platform/platformConfig';

const detectedPlatform = detectPlatform();

const initialState = {
  platform: detectedPlatform,
  isEventsPlatform: detectedPlatform === PLATFORMS.EVENTS,
};

export const platformSlice = createSlice({
  name: 'platform',
  initialState,
  reducers: {
    setPlatform: (state, action) => {
      state.platform = action.payload;
      state.isEventsPlatform = action.payload === PLATFORMS.EVENTS;
    },
  },
});

export const { setPlatform } = platformSlice.actions;

export const selectPlatform = state => state.platform.platform;
export const selectIsEventsPlatform = state => state.platform.isEventsPlatform;

export default platformSlice.reducer;
